class EfInfiniteScroll {
    get observerTargetId() {
        this.lastIndexOnList = this.lastIndexOnList || 10

        return `${this.listId}-item-${this.lastIndexOnList}`
    }

    $onInit() {
        this.initAction()
    }

    $onDestroy() {
        this.destroyAction()
    }

    handleNewListItem(item) {
        this._initScrollObserver()

        if (item.listItemId === this.observerTargetId) {
            this._updateObserverTarget()
        }
    }

    _initScrollObserver() {
        if (this.observer) return

        const callback = ([entry]) => {
            if (entry && entry.isIntersecting) {
                this.triggerAction()

                this.lastIndexOnList += 10
            }
        }

        const options = {
            root: document.getElementById(this.listId),
            rootMargin: '0px',
            threshold: 0.25
        }

        this.observer = new IntersectionObserver(callback, options)
    }

    _updateObserverTarget() {
        if (this.observerTarget) {
            this.observer.unobserve(this.observerTarget)
        }

        this.observerTarget = this.observer.root.querySelector(`#${this.observerTargetId}`)

        this.observer.observe(this.observerTarget)
    }
}

angular
    .module('eficienciaFiscalModule')
    .component('efInfiniteScroll', {
        controller: EfInfiniteScroll,
        transclude: 'true',
        bindings: {
            listId: '@',
            initAction: '&',
            triggerAction: '&',
            destroyAction: '&'
        },
        template: `
        <ul id="{{ $ctrl.listId }}" ng-transclude></ul>
        `
    })

angular
    .module('eficienciaFiscalModule')
    .component('efInfiniteScrollListItem', {
        controller: () => {
            return {
                $onInit() {
                    setTimeout(() => this.listCtrl.handleNewListItem(this), 0)
                }
            }
        },
        require: {
            listCtrl: '^efInfiniteScroll'
        },
        transclude: 'true',
        bindings: {
            listItemId: '@'
        },
        template: `
        <li id="{{ $ctrl.listItemId }}" ng-transclude></li>
        `
    })
